import config from './config';

export class APIError extends Error {
  constructor(code, ...params) {
    super(...params);
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, APIError)
    }
    this.code = code;
  }
};

export default {
  get(path, payload) {
    return this.send('GET', path, payload);
  },

  post(path, payload) {
    return this.mutate('POST', path, payload)
  },

  patch(path, payload) {
    return this.mutate('PATCH', path, payload);
  },

  put(path, payload) {
    return this.mutate('PUT', path, payload);
  },

  delete(path, payload) {
    return this.mutate('DELETE', path, payload);
  },

  mutate(method, path, payload) {
    return this.send(method, path, null, payload);
  },

  send(method, path, query, body) {
    const token = sessionStorage.getItem('USR');

    return fetch(`${config.api_url}${path}${query ? `?${new URLSearchParams(query).toString()}` : ''}`, {
      method,
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    })
      .then(rs => {
        if (rs.ok) return rs.json();
        return rs
          .json()
          .then(js => { throw new APIError(rs.status, js.error); });
      });
  }
}
